import { Text } from "react-native";
import { MultiSelect } from "react-multi-select-component";

interface AgentMultiProps {
  agentOptions: { label: string; value: string }[];
  userId: string;
  locationIds: string[];
  onChange: (userId: string, locationIds: string[]) => void;
}

const AgentMulti = ({
  agentOptions,
  userId,
  locationIds,
  onChange,
}: AgentMultiProps) => {
  const selectedOptions = agentOptions.filter((option) =>
    locationIds.includes(option.value)
  );

  const handleChange = (options: { label: string; value: string }[]) => {
    onChange(
      userId,
      options.map((option) => option.value)
    );
  };

  if (agentOptions.length === 0) {
    return <Text>None</Text>;
  }

  return (
    <MultiSelect
      options={agentOptions}
      value={selectedOptions}
      onChange={handleChange}
      labelledBy="Select"
      className="text-sm"
      ClearSelectedIcon={null}
      valueRenderer={(selected, _options) => {
        return `${selected.length} location${
          selected.length === 1 ? "" : "s"
        } selected`;
      }}
      overrideStrings={{ allItemsAreSelected: "All locations" }}
    />
  );
};

export default AgentMulti;
